<script>
import options from "./InvestmentFundTable.options"
export default options
</script>

<template>
  <article class="nyk-investment-fund-table">
    <SearchInputField
      :initSearchParam="searchInput"
      :onEnterCallback="inputEnter"
      :onChangeCallback="inputChanged"
      :placeholder="model.searchPlaceholderLabel" 
      :searchInputAriaLabel="model.searchPlaceholderLabel"
      :searchIconLabel="model?.searchIconLabel"
      :searchButtonAriaLabel="model?.searchButtonAriaLabel"
      :searchResetAriaLabel="model?.closeIconLabel"
      />

    <template v-if="tabs.length > 0">
      <FilterTabs
        :tabs="tabs"
        :initActiveTab="activeFilter"
        :callback="filterChanged" />
      <div
        v-for="tab in tabs"
        :key="tab.id"
        :id="`tab-panel-${tab.id}`"
        role="tabpanel"
        :aria-labelledby="tab.id"
        v-show="tab.id === activeFilter">
        <DynamicTable v-if="tab.id === activeFilter" :headers="tableHeaders" :rows="tableRows" />
      </div>
    </template>
    <DynamicTable v-else :headers="tableHeaders" :rows="tableRows" />
  </article>
</template>
